import CardProductFlip from "./card-product-flip";

export default CardProductFlip;